import React, { useState } from "react";
import { Collapse, message } from "antd";

import Breadcrumb from "../../components/Breadcrumb";
import AddFaqs from "../../components/FileUpload/Faqs/AddFaqs";
import FaqTable from "../../components/FileUpload/Faqs/FaqTable";

import { useAddNewFAQ,useGetFAQList,useDeleteFAQ,useUpdateFAQ } from "../../hooks/file-upload.hooks";
  
const Faqs = () => {
  const [applicationId,setApplicationId] = useState();
 
  const {
    isLoading: isLoadingFAQData,
    data: faqData,
    refetch: reloadGetFAQ,
  } = useGetFAQList(applicationId,{enabled: !! applicationId});

  const { mutate: createFAQ } = useAddNewFAQ({
    onSuccess: () => {
      message.success("FAQ Data Added Successfully");
      reloadGetFAQ();
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });
  
  const { mutate: removeFAQ } = useDeleteFAQ({
    onSuccess: () => {
      message.success("FAQ Data Deleted Successfully");      
      reloadGetFAQ();
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const { mutate: updateFAQ } = useUpdateFAQ({
    onSuccess: () => {
      message.success("FAQ Updated Successfully");      
      reloadGetFAQ();
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const onSubmit = (newFAQ) =>{ 
    newFAQ['_id'] = applicationId;
    createFAQ(newFAQ);
  };

  const editFAQ = (data) =>{
    updateFAQ({appid:applicationId,id:data._id,faq:data});
  }

  const deleteFAQ = (id) =>{
    removeFAQ({appId:applicationId,id:id});
  }
  
  return (
    <div>
      <div className="container_aa">
        <h3>FAQs</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              { path: "faqs", breadcrumbName: "FAQs" },
            ]}
          />
      </div>
      <div className="container_ab">
        <div className="container_style_2">
          <Collapse defaultActiveKey={["1_1"]} expandIconPosition="end">
            <Collapse.Panel header="FAQs" key="1_1" arrow="right">
              <div className="is_form_1">
                <AddFaqs onSubmit={onSubmit} getApplicationId={(appId)=>setApplicationId(appId)} applicationId={applicationId}/>
                {!isLoadingFAQData && faqData?.length > 0 ?(
                  <FaqTable
                    faqList={faqData}
                    editFAQ={editFAQ}
                    deleteFAQ={deleteFAQ}                    
                    label="FAQ List"                    
                  />
                ):null}
              </div>
            </Collapse.Panel>
          </Collapse>
        </div>

      </div>       
    </div>
  )
}
export default Faqs;
